import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetItemQuery, usePublishMutation } from '../store/docApi';
import { Box, CircularProgress, Alert, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Publish as PublishIcon } from '@mui/icons-material';
import QuestHeader from './QuestHeader';
import QuestMap from './QuestMap';
import QuestSteps from './QuestSteps';

function QuestDetails() {
  const { questId } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(null);

  const { data: quest, isLoading, error } = useGetItemQuery({ label: 'quest', id: questId });
  const [publish, { isLoading: isPublishing }] = usePublishMutation();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        Error loading quest: {error.message}
      </Alert>
    );
  }

  if (!quest) {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        Quest not found
      </Alert>
    );
  }

  const handleStepClick = (step) => {
    setCurrentStep(step);
  };

  const handleCloseStep = () => {
    setCurrentStep(null);
  };

  const handlePublish = async () => {
    try {
      await publish({ label: quest.label, pk: quest.pk, id: quest.id }).unwrap();
      navigate('/published');
    } catch (error) {
      console.error('Failed to publish quest:', error);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 2
        }}
      >
        <QuestHeader quest={quest} />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton size="small" color="default" onClick={() => navigate('/quests')} title="Back to Quests">
            <ArrowBackIcon />
          </IconButton>
          <IconButton size="small" color="primary" onClick={handlePublish} disabled={isPublishing} title="Publish Quest">
            <PublishIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 200px)',
          gap: 2
        }}
      >
        <Box sx={{ flex: 1, minHeight: 300 }}>
          <QuestMap steps={quest.steps} currentStep={currentStep} onMarkerClick={handleStepClick} />
        </Box>
        <Box sx={{ overflow: 'auto' }}>
          <QuestSteps steps={quest.steps} currentStep={currentStep} onStepClick={handleStepClick} onCloseStep={handleCloseStep} />
        </Box>
      </Box>
    </Box>
  );
}

export default QuestDetails;
